import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function RestaurantMenu(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M10 1a1 1 0 000 2h3a1 1 0 100-2h-3zM6.002 8.208C4.917 9.389 4.22 11.026 4.044 13H11v-2a2 2 0 012-2h4.487c-.378-.56-.938-1.12-1.657-1.613C14.607 6.55 13.051 6 11.5 6c-2.397 0-4.243.842-5.498 2.208zM13 14v6h7v-9h-7v3zm-2 5v1a2 2 0 002 2h7a2 2 0 002-2v-9a2 2 0 00-2-2h-.258c-.502-1.274-1.544-2.414-2.782-3.262C15.447 4.7 13.503 4 11.5 4 8.605 4 6.202 5.033 4.53 6.855 2.864 8.667 2 11.174 2 14a1 1 0 001 1h8v2H3a1 1 0 100 2h8zm4.09-6a1 1 0 100 2H18a1 1 0 100-2h-2.91zm0 3a1 1 0 100 2H18a1 1 0 100-2h-2.91z",
    clipRule: "evenodd"
  }));
}

export default RestaurantMenu;